var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ejs-tab',{ref:"unitsTab",attrs:{"id":"element"}},[_c('e-tabitems',[_c('e-tabitem',{attrs:{"header":_vm.headerText1,"content":_vm.tradingTemplate}}),_c('e-tabitem',{attrs:{"header":_vm.headerText2,"content":_vm.volumeTemplate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }